export const handleLogout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("projectID");
  window.location.reload(false);
  window.location.href = "/";
};
